import { MantineColor } from "@mantine/core";
import { CSSProperties, forwardRef, MouseEventHandler } from "react";

import { colors } from "#app/theme/v1/colors";
import { radius } from "#app/theme/v1/radius";
import { spacing } from "#app/theme/v1/spacing";
import { Box } from "#shared/view/components/Box";

type Props = {
  color?: "blue" | "gray" | "violet";
  children?: React.ReactNode;
  backgroundColor?: MantineColor;
  onClick?: MouseEventHandler<HTMLDivElement>;
  style?: CSSProperties;
};

const PADDING_VERTICAL = parseInt(spacing.xxs) || 0;
export const PADDING_HORIZONTAL = parseInt(spacing.xs) || 0;

export const SectionWrapper = forwardRef<HTMLDivElement, Props>(
  ({ color, children, backgroundColor, onClick, style }, ref) => {
    return (
      <Box
        ref={ref}
        style={{
          ...getStyles({ color: color || "gray", backgroundColor, onClick }).panelWrapper,
          ...style,
        }}
        onClick={onClick}
      >
        {children}
      </Box>
    );
  },
);

const getColor = (color: "blue" | "gray" | "violet") => {
  switch (color) {
    case "blue":
      return colors.blue[5];
    case "gray":
      return colors.gray[3];
    case "violet":
      return colors.violet[6];
    default:
      return colors.gray[3];
  }
};

const getStyles = ({
  color,
  backgroundColor,
  onClick,
}: {
  color: "blue" | "gray" | "violet";
  backgroundColor?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}): Record<string, CSSProperties> => ({
  panelWrapper: {
    border: `1px solid`,
    borderColor: getColor(color),
    borderRadius: radius.sm,
    paddingTop: PADDING_VERTICAL,
    paddingBottom: PADDING_VERTICAL,
    paddingLeft: PADDING_HORIZONTAL,
    paddingRight: PADDING_HORIZONTAL,
    backgroundColor: backgroundColor ? colors[backgroundColor]?.[0] : undefined,
    cursor: onClick ? "pointer" : undefined,
  },
});
